import { render, staticRenderFns } from "./EditVdoLiveSet.vue?vue&type=template&id=0b55ade7&scoped=true&"
import script from "./EditVdoLiveSet.vue?vue&type=script&lang=js&"
export * from "./EditVdoLiveSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55ade7",
  null
  
)

export default component.exports